<template>
    <v-container class="fill-height justify-start align-start">
        <v-row>
            <v-col >
                <v-form v-model="valid">
                    <v-card>
                        <v-toolbar>
                            <v-toolbar-title>{{ title }}</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" sm="12" md="6">
                                    <v-text-field label="Name" variant="outlined" v-model="name" ></v-text-field>
                                    <v-text-field label="Code" variant="outlined" v-model="code" placeholder="Will auto generate if left empty" ></v-text-field>
                                    <v-select density="compact" variant="outlined" :items="stateItems" v-model="state" 
                                        label="State"></v-select>
                                    <v-combobox variant="outlined" clearable item-title="name"
                                            item-value="companyID" label="Company" :items="companies"
                                            v-model="selectedCompany" @update:search="onCompanyUpdate"></v-combobox>
                                    <v-text-field label="Quantity" variant="outlined" v-model="quantity" ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-row>
                                        <v-col>
                                            <v-card >
                                                <v-toolbar>
                                                    <v-toolbar-title>Defects</v-toolbar-title>
                                                    <v-btn variant="elevated" color="primary" class="ml-2 mr-3" @click="showSearchBox" >Add</v-btn>
                                                </v-toolbar>
                                                <v-container :hidden="!showSearchDefect">
                                                    <v-row class="justify-space-between" >
                                                        <v-col class="pa-2" lg="6" xl="7">
                                                            <defect-combo-box label="Search Defect" variant="outlined" clearable item-title="name"
                                                                        item-value="defectId"
                                                                        v-model="defect" ></defect-combo-box>
                                                        </v-col>
                                                        <v-col class="pa-2" cols="auto" >
                                                            <v-btn variant="elevated" class="mr-3" @click="hideSearchBox" >Cancel</v-btn>
                                                            <v-btn variant="elevated" color="primary" class="mr-3" @click="assignDefect" >Save</v-btn>
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                                <v-list>
                                                    <v-list-item v-for="defect in defects"
                                                        :key="defect.defectId"
                                                        class="py-3">
                                                        <v-list-item-title>{{ defect.name }}</v-list-item-title>
                                                        <template v-slot:append>
                                                            <v-btn
                                                                color="grey-lighten-1"
                                                                icon="mdi-delete"
                                                                variant="text"
                                                                @click="deleteEnity(defect.defectId, defect.name)"
                                                            ></v-btn>
                                                        </template>
                                                    </v-list-item>
                                                </v-list>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                    
                                    <v-row>
                                        <v-col>
                                            <quill-editor theme="snow" toolbar="essential" style="height: 400px" v-model:content="description" contentType="html"></quill-editor>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn variant="elevated" class="ml-2 mr-3"
                                @click="$router.push('/projects')">Back</v-btn>
                            <v-btn variant="elevated" color="primary" class="mr-3" @click="save">Save</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-col>
        </v-row>
        <v-dialog max-width="500" v-model="dialogOn">
            <v-card title="Unassigne Defect">
            <v-card-text>Are you sure you whant to unassigne defect {{ defectName }}</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text="Dismist" @click="dialogOn = false"></v-btn>
                <v-btn text="Delete" color="error" @click="confirmDelete"></v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar" >{{ message }}
            <template v-slot:actions>
                <v-btn
                    icon="mdi-close"
                    variant="text"
                    @click="snackbar = false"
                    :timeout="timeout"
                    ></v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>

<script>
import DefectComboBox from '@/components/DefectComboBox.vue';
import CompanyApi from '@/services/CompanyApi'
import ProjectApi from '../services/ProjectApi'
import DefectApi from '../services/DefectApi'

export default {
    name: 'ProjectEdit',
    data() {
        return {
            id: '',
            valid: false,
            companies: [],
            defects: [],
            name: "",
            code: "",
            quantity: null,
            description: "",
            selectedCompany: null,
            defect: null,
            showSearchDefect: false,
            title: '',
            stateItems: ['Active', 'Inactive'],
            state: 'Active',
            snackbar: false,
            dialogOn: false,
            message: "",
            timeout: 2000,
        }
    },
    components: {
        DefectComboBox
    },
    mounted() {
        this.id = this.$route.params.id;
        
        if (!isNaN(this.id)) {
            this.title = "Edit";
            ProjectApi.get(this.id).then((response) => {
                if (response && response.data) {

                    this.name = response.data.name;
                    this.code = response.data.code;
                    this.description = response.data.description;
                    this.quantity = response.data.quantity;
                    this.state = response.data.enabled ? "Active" : 'Inactive'
                    
                    if(response.data.company) {
                        this.selectedCompany = { companyID: response.data.company.companyId, name: response.data.company.name }
                    }

                    if(response.data.defects) {
                        let df = response.data.defects;
                        for(let i in df) {
                            this.defects.push({ defectId: df[i].defectId, name: df[i].name })
                        }
                    }
                }
            })
        }
        else {
            this.title = "Create";
        }
        this.serarchCompanies()
    },
    methods: {
        onCompanyUpdate(input) {
            this.serarchCompanies(input);
        },
        serarchCompanies(term) {
            CompanyApi.search({ offset: 0, limit: 25, search: term }).then((response) => {
                if (response && response.data && Array.isArray(response.data.companies)) {
                    this.companies = response.data.companies;
                }
            })
        },
        showSearchBox() {
            this.showSearchDefect = true;
        },
        hideSearchBox() {
            this.showSearchDefect = false;
        },
        assignDefect() {
            if(this.defect == null || this.defect?.defectId == null) {
                this.message = 'Pleas select a defect first!';
                this.snackbar = true;
                return;
            }
            
            let item = this.defects.find((a) => a.defectId == this.defect?.defectId);
            
            if(item) {
                this.message = 'Defect already present in the list!';
                this.snackbar = true;
                return;
            }
            DefectApi.get(this.defect?.defectId).then((response) => {
                if(response && response.data) {
                    this.defects.push({ defectId: response.data.defectId, name: response.data.name });
                    this.hideSearchBox();
                    this.defect = null;
                    this.save()
                }
            })
            
        },
        deleteEnity(id, code) {
            this.defectId = id;
            this.defectName = code;
            this.dialogOn = true;
        },
        confirmDelete() {
            var index = this.defects.map(e => e.defectId).indexOf(this.defectId);
            if(index != -1) {
                this.defects.splice(index, 1);
                this.dialogOn = false;
                this.save();
            }
        },
        save() {
            if(!isNaN(this.id)) {
                var payload = {
                    projectId: this.id,
                    name: this.name,
                    code: this.code,
                    description: this.description,
                    quantity: this.quantity,
                    companyId: this.selectedCompany.companyID,
                    enabled: this.state == "Active" ? true : false,
                    defects: null
                };
                if (this.defects) {
                    payload.defects = [];
                    for(let i in this.defects) {
                        payload.defects.push({ defectId: this.defects[i].defectId, name: this.defects[i].name });
                    }
                }
                
                ProjectApi.put(this.id, payload).then((response) => {
                    if (response && response.data) {
                        this.code = response.data.code;
                        this.message = response.data.state.message;
                        this.snackbar = true;
                    }
                })
            }
            else {
                var body = {
                    name: this.name,
                    code: this.code,
                    description: this.description,
                    companyId: this.selectedCompany.companyID,
                    quantity: this.quantity,
                    enabled: this.state == "Active" ? true : false
                };
                if (this.defects) {
                    body.defects = [];
                    for(let i in this.defects) {
                        body.defects.push({ defectId: this.defects[i].defectId, name: this.defects[i].name });
                    }
                }
                ProjectApi.post(body).then((response) => {
                    if (response && response.data) {
                        this.code = response.data.code;
                        this.id = response.data.projectId;
                        this.$router.push(`/projects/${this.id}`);

                        this.message = response.data.state.message;
                        this.snackbar = true;
                    }
                })
            }
        }
    }
}
</script>